import { useRef } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import * as THREE from 'three'
import {decideRuntimeBudget,nextFightDpr} from './fightRuntimeBudgetGovernor'

export type RuntimePerformanceSnapshot={
  fps:number
  dpr:number
  pressure:'critical'|'high'|'normal'
  samples:number
  adjusted:boolean
  at:number
}

export function AdaptivePerformanceGovernor(){
  const {gl,scene,setDpr}=useThree()
  const sample=useRef({elapsed:0,frames:0,dpr:THREE.MathUtils.clamp(gl.getPixelRatio(),.7,1.15),stable:0,pressureSamples:0,lastAdjustAt:0,samples:0,framesMs:[] as number[]})
  useFrame((_,dt)=>{
    const state=sample.current
    state.elapsed+=Math.min(.25,Math.max(0,dt))
    state.frames++
    state.framesMs.push(Math.min(200,Math.max(0,dt*1000)))
    if(state.elapsed<1.5)return
    const fps=state.frames/Math.max(.001,state.elapsed),now=performance.now()
    const durations=[...state.framesMs].sort((a,b)=>a-b),p95=durations[Math.min(durations.length-1,Math.floor(durations.length*.95))]??16.7
    const budget=decideRuntimeBudget({fps,p95})
    state.samples++
    const dprDecision=nextFightDpr({
      dpr:state.dpr,pressureSamples:state.pressureSamples,stable:state.stable,lastAdjustAt:state.lastAdjustAt,
    },{fps,p95},now)
    state.pressureSamples=dprDecision.pressureSamples;state.stable=dprDecision.stable;state.lastAdjustAt=dprDecision.lastAdjustAt
    const next=dprDecision.dpr,adjusted=dprDecision.adjusted
    if(adjusted){state.dpr=next;setDpr(next)}
    gl.shadowMap.enabled=budget.reason!=='critical-frame-budget'
    const snapshot:RuntimePerformanceSnapshot={
      fps:Number(fps.toFixed(1)),
      dpr:Number(state.dpr.toFixed(2)),
      pressure:fps<28?'critical':fps<42?'high':'normal',
      samples:state.samples,
      adjusted,
      at:now,
    }
    scene.userData.inyronPerformance=snapshot
    scene.userData.inyronRuntimeBudget=budget
    ;(window as typeof window&{__INYRON_RUNTIME_BUDGET__?:typeof budget}).__INYRON_RUNTIME_BUDGET__=budget
    ;(window as typeof window&{__INYRON_RUNTIME_PERFORMANCE__?:RuntimePerformanceSnapshot}).__INYRON_RUNTIME_PERFORMANCE__=snapshot
    state.elapsed=0;state.frames=0;state.framesMs.length=0
  })
  return null
}